'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lsamples_Sealed$package$Horse$1(name, age, color) {
  this.sZ = null;
  this.sX = 0;
  this.sY = null;
  this.sZ = name;
  this.sX = age;
  this.sY = color;
}
export { $c_Lsamples_Sealed$package$Horse$1 as $c_Lsamples_Sealed$package$Horse$1 };
$p = $c_Lsamples_Sealed$package$Horse$1.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_Sealed$package$Horse$1;
/** @constructor */
function $h_Lsamples_Sealed$package$Horse$1() {
}
export { $h_Lsamples_Sealed$package$Horse$1 as $h_Lsamples_Sealed$package$Horse$1 };
$h_Lsamples_Sealed$package$Horse$1.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.m = (function() {
  var acc = (-889275714);
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, 69913533);
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.sZ));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, this.sX);
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.sY));
  return $j_java$002elang$002e$002dObject.$m_sr_Statics$().an(acc, 3);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsamples_Sealed$package$Horse$1)) {
    if (((this.sX === x$0.sX) && (this.sZ === x$0.sZ))) {
      var x = this.sY;
      var x$2 = x$0.sY;
      return ((x === null) ? (x$2 === null) : (x === x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.b = (function() {
  return $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().ah(this);
});
$p.n = (function() {
  return 3;
});
$p.o = (function() {
  return "Horse";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return this.sZ;
      break;
    }
    case 1: {
      return this.sX;
      break;
    }
    case 2: {
      return this.sY;
      break;
    }
    default: {
      throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__I__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
function $isArrayOf_Lsamples_Sealed$package$Horse$1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eo)));
}
export { $isArrayOf_Lsamples_Sealed$package$Horse$1 as $isArrayOf_Lsamples_Sealed$package$Horse$1 };
var $d_Lsamples_Sealed$package$Horse$1 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_Sealed$package$Horse$1, "samples.Sealed$package$Horse$1", ({
  eo: 1,
  by: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lsamples_Sealed$package$Horse$1 as $d_Lsamples_Sealed$package$Horse$1 };
